import React from 'react';

type SetEntitlementFunc = () => void;

export const EntitlementContext =
  React.createContext<SetEntitlementFunc | null>(null);

export function useEntitlementProblemNotifier() {
  const context = React.useContext(EntitlementContext);
  return context;
}
